export enum LogoIconName {
  AboutYouLogo,
  AY10_bg_BG,
  AY10_CZ_SI,
  AY10_da_DK,
  AY10_de_DE,
  AY10_en_ZZ,
  AY10_es_ES,
  AY10_es_ZZ,
  AY10_et_EE,
  AY10_fi_FI,
  AY10_fr_BE_CH_LU,
  AY10_fr_FR,
  AY10_GR_CY,
  AY10_hr_HR,
  AY10_hu_HU,
  AY10_it_CH,
  AY10_it_IT,
  AY10_lt_LT,
  AY10_LV_EE,
  AY10_lv_LV,
  AY10_nl_BE_NL,
  AY10_no_NO,
  AY10_pl_PL,
  AY10_pt_PT,
  AY10_ro_RO,
  AY10_sk_SK,
  AY10_sv_SE,
  AY10F_bg_BG,
  AY10F_CZ_SI,
  AY10F_da_DK,
  AY10F_de_DE,
  AY10F_en_ZZ,
  AY10F_es_ES,
  AY10F_es_ZZ,
  AY10F_et_EE,
  AY10F_fi_FI,
  AY10F_fr_BE_CH_LU,
  AY10F_fr_FR,
  AY10F_GR_CY,
  AY10F_hr_HR,
  AY10F_hu_HU,
  AY10F_it_CH,
  AY10F_it_IT,
  AY10F_lt_LT,
  AY10F_LV_EE,
  AY10F_lv_LV,
  AY10F_nl_BE_NL,
  AY10F_no_NO,
  AY10F_pl_PL,
  AY10F_pt_PT,
  AY10F_ro_RO,
  AY10F_sk_SK,
  AY10F_sv_SE,
  CampaignLogo,
  CampaignLogoIT,
  CampaignLogoLT,
  CampaignLogoLV,
  CampaignLogoPL,
}

export const logoIconAssets: {
  [key in LogoIconName]: string;
} = {
  [LogoIconName.AboutYouLogo]: require('./logo-default.svg'),
  [LogoIconName.AY10_bg_BG]: require('./ay-anniversary/bg_BG.svg'),
  [LogoIconName.AY10_CZ_SI]: require('./ay-anniversary/CZ-SI.svg'),
  [LogoIconName.AY10_da_DK]: require('./ay-anniversary/da_DK.svg'),
  [LogoIconName.AY10_de_DE]: require('./ay-anniversary/de_DE.svg'),
  [LogoIconName.AY10_en_ZZ]: require('./ay-anniversary/en_ZZ.svg'),
  [LogoIconName.AY10_es_ES]: require('./ay-anniversary/es_ES.svg'),
  [LogoIconName.AY10_es_ZZ]: require('./ay-anniversary/es_ZZ.svg'),
  [LogoIconName.AY10_et_EE]: require('./ay-anniversary/et_EE.svg'),
  [LogoIconName.AY10_fi_FI]: require('./ay-anniversary/fi_FI.svg'),
  [LogoIconName.AY10_fr_BE_CH_LU]: require('./ay-anniversary/fr_BE-CH-LU.svg'),
  [LogoIconName.AY10_fr_FR]: require('./ay-anniversary/fr_FR.svg'),
  [LogoIconName.AY10_GR_CY]: require('./ay-anniversary/GR-CY.svg'),
  [LogoIconName.AY10_hr_HR]: require('./ay-anniversary/hr_HR.svg'),
  [LogoIconName.AY10_hu_HU]: require('./ay-anniversary/hu_HU.svg'),
  [LogoIconName.AY10_it_CH]: require('./ay-anniversary/it_CH.svg'),
  [LogoIconName.AY10_it_IT]: require('./ay-anniversary/it_IT.svg'),
  [LogoIconName.AY10_lt_LT]: require('./ay-anniversary/lt_LT.svg'),
  [LogoIconName.AY10_LV_EE]: require('./ay-anniversary/ru_LV-EE.svg'),
  [LogoIconName.AY10_lv_LV]: require('./ay-anniversary/lv_LV.svg'),
  [LogoIconName.AY10_nl_BE_NL]: require('./ay-anniversary/nl_BE-NL.svg'),
  [LogoIconName.AY10_no_NO]: require('./ay-anniversary/no_NO.svg'),
  [LogoIconName.AY10_pl_PL]: require('./ay-anniversary/pl_PL.svg'),
  [LogoIconName.AY10_pt_PT]: require('./ay-anniversary/pt_PT.svg'),
  [LogoIconName.AY10_ro_RO]: require('./ay-anniversary/ro_RO.svg'),
  [LogoIconName.AY10_sk_SK]: require('./ay-anniversary/sk_SK.svg'),
  [LogoIconName.AY10_sv_SE]: require('./ay-anniversary/sv_SE.svg'),
  [LogoIconName.AY10F_bg_BG]: require('./ay-anniversary-full/bg_BG.svg'),
  [LogoIconName.AY10F_CZ_SI]: require('./ay-anniversary-full/CZ-SI.svg'),
  [LogoIconName.AY10F_da_DK]: require('./ay-anniversary-full/da_DK.svg'),
  [LogoIconName.AY10F_de_DE]: require('./ay-anniversary-full/de_DE.svg'),
  [LogoIconName.AY10F_en_ZZ]: require('./ay-anniversary-full/en_ZZ.svg'),
  [LogoIconName.AY10F_es_ES]: require('./ay-anniversary-full/es_ES.svg'),
  [LogoIconName.AY10F_es_ZZ]: require('./ay-anniversary-full/es_ZZ.svg'),
  [LogoIconName.AY10F_et_EE]: require('./ay-anniversary-full/et_EE.svg'),
  [LogoIconName.AY10F_fi_FI]: require('./ay-anniversary-full/fi_FI.svg'),
  [LogoIconName.AY10F_fr_BE_CH_LU]: require('./ay-anniversary-full/fr_BE-CH-LU.svg'),
  [LogoIconName.AY10F_fr_FR]: require('./ay-anniversary-full/fr_FR.svg'),
  [LogoIconName.AY10F_GR_CY]: require('./ay-anniversary-full/GR-CY.svg'),
  [LogoIconName.AY10F_hr_HR]: require('./ay-anniversary-full/hr_HR.svg'),
  [LogoIconName.AY10F_hu_HU]: require('./ay-anniversary-full/hu_HU.svg'),
  [LogoIconName.AY10F_it_CH]: require('./ay-anniversary-full/it_CH.svg'),
  [LogoIconName.AY10F_it_IT]: require('./ay-anniversary-full/it_IT.svg'),
  [LogoIconName.AY10F_lt_LT]: require('./ay-anniversary-full/lt_LT.svg'),
  [LogoIconName.AY10F_LV_EE]: require('./ay-anniversary-full/ru_LV-EE.svg'),
  [LogoIconName.AY10F_lv_LV]: require('./ay-anniversary-full/lv_LV.svg'),
  [LogoIconName.AY10F_nl_BE_NL]: require('./ay-anniversary-full/nl_BE-NL.svg'),
  [LogoIconName.AY10F_no_NO]: require('./ay-anniversary-full/no_NO.svg'),
  [LogoIconName.AY10F_pl_PL]: require('./ay-anniversary-full/pl_PL.svg'),
  [LogoIconName.AY10F_pt_PT]: require('./ay-anniversary-full/pt_PT.svg'),
  [LogoIconName.AY10F_ro_RO]: require('./ay-anniversary-full/ro_RO.svg'),
  [LogoIconName.AY10F_sk_SK]: require('./ay-anniversary-full/sk_SK.svg'),
  [LogoIconName.AY10F_sv_SE]: require('./ay-anniversary-full/sv_SE.svg'),
  [LogoIconName.CampaignLogo]: require('./ay-campaign-logo.svg'),
  [LogoIconName.CampaignLogoIT]: require('./ay-campaign-logo-it.svg'),
  [LogoIconName.CampaignLogoLT]: require('./ay-campaign-logo-lt.svg'),
  [LogoIconName.CampaignLogoLV]: require('./ay-campaign-logo-lv.svg'),
  [LogoIconName.CampaignLogoPL]: require('./ay-campaign-logo-pl.svg'),
};
